import React from "react";
import * as logApi from "../../api/logApi";

class ViewLogs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      selectedLog: "",
      logContent: [],
      filteredLogContent: [],
      loading: false,
      error: "",
      hideInfoLogs: false,
    };
  }

  componentDidMount() {
    this.loadLogFiles();
  }

  loadLogFiles = async () => {
    try {
      const logFiles = await logApi.getLogFiles();
      this.setState({ logs: logFiles });

      if (logFiles.length > 0) {
        this.setState({ selectedLog: logFiles[0].fileName });
        this.loadLogContent(logFiles[0].fileName);
      }
    } catch (error) {
      this.setState({ error: error.message });
    }
  };

  loadLogContent = async (fileName) => {
    this.setState({ loading: true, error: "" });

    try {
      const logData = await logApi.getLogContent(fileName);
      this.setState({
        logContent: logData,
        filteredLogContent: this.filterLogs(logData, this.state.hideInfoLogs)
      });
    } catch (error) {
      this.setState({ error: error.message });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleLogChange = (event) => {
    const selectedLog = event.target.value;
    this.setState({ selectedLog });
    this.loadLogContent(selectedLog);
  };

  toggleInfoLogs = () => {
    this.setState((prevState) => {
      const newHideInfoLogs = !prevState.hideInfoLogs;
      return {
        hideInfoLogs: newHideInfoLogs,
        filteredLogContent: this.filterLogs(prevState.logContent, newHideInfoLogs),
      };
    });
  };

  filterLogs = (logs, hideInfo) => {
    if (!hideInfo) return logs;
    return logs.filter(line => !line.includes("[INF]"));
  };

  render() {
    const { logs, selectedLog, filteredLogContent, loading, error, hideInfoLogs } = this.state;

    return (
      <div style={{ padding: "20px", marginTop: "60px" }}>
        <h2>Application Logs</h2>

        {/* Log file selection dropdown */}
        <label htmlFor="logSelect"><strong>Select Log File:</strong></label>
        <select
          id="logSelect"
          value={selectedLog}
          onChange={this.handleLogChange}
          style={{ marginLeft: "10px", padding: "5px" }}
        >
          {logs.map((log, index) => (
            <option key={index} value={log.fileName}>
              {new Date(log.createdAt).toLocaleString()} - {log.fileName}
            </option>
          ))}
        </select>

        {/* Toggle Button */}
        <button
          onClick={this.toggleInfoLogs}
          style={{ marginLeft: "10px", padding: "5px", cursor: "pointer" }}
        >
          {hideInfoLogs ? "Show All Logs" : "Hide [INF] Logs"}
        </button>

        {/* Error message */}
        {error && <p style={{ color: "red" }}>Error: {error}</p>}

        {/* Loading indicator */}
        {loading ? <p>Loading log content...</p> : null}

        {/* Log Content Display */}
        <div
          style={{
            marginTop: "20px",
            padding: "10px",
            backgroundColor: "#f4f4f4",
            borderRadius: "5px",
            height: "1000px",
            overflowY: "scroll",
            whiteSpace: "pre-wrap",
            fontFamily: "monospace",
          }}
        >
          {filteredLogContent.length > 0 ? (
            filteredLogContent.map((line, index) => <p key={index}>{line}</p>)
          ) : (
            <p>No log content available.</p>
          )}
        </div>
      </div>
    );
  }
}

export default ViewLogs;
